import * as Sentry from '@sentry/vue';

export function initializeSentry(app) {
  const dsn = import.meta.env.VITE_SENTRY_DSN?.trim();
  if (!dsn) {
    if (import.meta.env.DEV) {
      console.info('[sentry] VITE_SENTRY_DSN is missing. Sentry is disabled.');
    }
    return null;
  }

  Sentry.init({
    app,
    dsn,
    environment:
      import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE || 'production',
    release: import.meta.env.VITE_APP_VERSION,
    sampleRate: Number(import.meta.env.VITE_SENTRY_ERROR_SAMPLE_RATE || '0.5'),
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    beforeSend(event) {
      const level = event.level || 'error';
      const hasException = Boolean(event.exception?.values?.length);
      if (hasException && (level === 'error' || level === 'fatal')) {
        return event;
      }

      return null;
    },
  });

  return Sentry;
}
